{
  "account-page-container": {
    "text": {
      "account": "Tài khoản của tôi",
      "logout": "Đăng xuất",
      "my-appointments": "Lịch hẹn của tôi",
      "my-profile": "Hồ sơ cá nhân",
      "my-salons": "Tiệm của tôi"
    }
  }
}
